import React from "react";
import { IReportsDetails } from "../types";
import ReportsDetailsForm from "./ReportsDetailsForm";
interface ReportsDetailProps {
  reportsDetails?: Array<IReportsDetails>;
}
const defaultReports = [
  {
    parentRow: true,
    tableName: "configReports",
  },
] as Array<IReportsDetails>;
const JobReportDetails = ({
  reportsDetails = defaultReports,
}: ReportsDetailProps): JSX.Element => {
  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full">
      <div className="text-quinary font-bold font-sans py-2 px-4">
        Report Details
      </div>
      <ReportsDetailsForm reportsDetails={reportsDetails} />
    </div>
  );
};

export default JobReportDetails;
